export class Timer
{
    constructor()
    {
        this.duration = 0;
    }

    set(val)
    {
        this.duration = val;
    }

    get()
    {
        return this.duration;
    }
}